export const INSTAGRAM_HANDLE = "@allinprecisionwellnesspa";
export const INSTAGRAM_URL = "https://www.instagram.com/allinprecisionwellnesspa/";

// Curated snapshot of the practice's own recent Instagram posts.
// Real permalinks + locally hosted thumbnails captured from the account's
// official embed. Refresh by re-capturing tiles and updating this list.
// Fields: url, thumbnail, alt, isVideo, isCarousel, pinned
export const CURATED_POSTS = [
  {
    url: "https://www.instagram.com/p/DeRqD2-y3m-/",
    thumbnail: "/images/instagram/post1.jpg",
    alt: "Dr. Jill talking to the camera outdoors about a women's health conference takeaway",
    isVideo: true,
  },
  {
    url: "https://www.instagram.com/p/DeNeBf2ln8u/",
    thumbnail: "/images/instagram/post2.jpg",
    alt: "Off to San Antonio: view from the plane on the way to a medical conference",
    isCarousel: true,
  },
  {
    url: "https://www.instagram.com/p/DeK3ea0yZNh/",
    thumbnail: "/images/instagram/post3.jpg",
    alt: "Attending The Women's Health Summit, October 8 to 10 in San Antonio",
  },
  {
    url: "https://www.instagram.com/p/DeIEYnPSzSj/",
    thumbnail: "/images/instagram/post4.jpg",
    alt: "Learning never stops: continuing education slide on appetite and metabolism",
  },
  {
    url: "https://www.instagram.com/p/Dd_-g12SHwu/",
    thumbnail: "/images/instagram/post5.jpg",
    alt: "Jill from All-In Precision Wellness with a reminder for patients",
    isVideo: true,
  },
  {
    url: "https://www.instagram.com/p/Dd7mTtyS72L/",
    thumbnail: "/images/instagram/post6.jpg",
    alt: "Inside the office: we take the time to truly understand you",
    isVideo: true,
  },
];
